<template>
	<div class="complete_setting_block">
		<div class="ring_block" v-if="settingComponent && activeDiamondVariation">

			<div class="mb-3 title_flex" @click="toggleRing()">
				<div class="font-active">
					<span> Ring Setting </span>
					<span v-if="settingComponent.num_side_lots" @click="show = true" :class="{ 'active': show }"> & accent details
					</span>
				</div>
				<SvgHeaderSvg class="for_mobile" :type="dropring ? 'up' : 'down'" />
			</div>
			<div class="d-none vto-do-not-remove">
				<span class="title">Design No.</span>
				<span class="description">{{settingComponent.main_sku}}</span>
			</div>
			<div class="ring_data_flex" :class="dropring ? 'show' : 'hide'">
				<div class="ring_box" @click="openModal(ringParams.newstyle)">
					<div class="ring_box_left">
						<h5 class="title_h5 capss">{{ settingComponent.sub_type }}</h5>
						<p class="mb-0">Style</p>
					</div>
					<div class="ring_box_right" v-if="settingComponent.sub_type === 'solitaire'">
						<img width="100" height="72" src="~/assets/loose_setting/solitaire.svg" alt="style" />
					</div>
					<div class="ring_box_right" v-if="settingComponent.sub_type === 'side-stone'">
						<img width="100" height="72" src="~/assets/loose_setting/sidestone.svg" alt="style" />
					</div>
					<div class="ring_box_right" v-if="settingComponent.sub_type === 'halo'">
						<img width="100" height="72" src="~/assets/loose_setting/halo.svg" alt="style" />
					</div>
					<div class="ring_box_right" v-if="settingComponent.sub_type === 'three-stone'">
						<img width="100" height="72" src="~/assets/loose_setting/threestone.svg" alt="style" />
					</div>
					<div class="ring_box_right" v-if="settingComponent.sub_type === 'vintage'">
						<img width="100" height="72" src="~/assets/loose_setting/vintage.svg" alt="style" />
					</div>
					<div class="top-icon">
						<SvgHeaderSvg :type="'ask'" />
					</div>
				</div>
				

				<div class="ring_box" v-if="!['pendant', 'earring'].includes(moduleSubType)" @click="openModal(ringParams.newProfile)">
					<div class="ring_box_left">
						<h5 class="title_h5 capss">{{ settingComponent.profile }}</h5>
						<p class="mb-0">Profile</p>
					</div>
					<div class="ring_box_right" v-if="settingComponent.profile === 'high'">
						<img width="100" height="72" src="~/assets/loose_setting/high.svg" alt="Halo" />
					</div>
					<div class="ring_box_right" v-if="settingComponent.profile === 'low'">
						<img width="100" height="72" src="~/assets/presetdetails/low.svg" alt="Halo" />
					</div>
					<div class="top-icon">
						<SvgHeaderSvg :type="'ask'" />
					</div>
				</div>
				

				<div class="ring_box" @click="openModal(ringParams.newBandwith)">
					<div class="ring_box_left">
						<h5 class="title_h5">{{ settingComponent.width }}</h5>
						<p class="mb-0">Band Width</p>
					</div>
					<div class="ring_box_right">
						<img width="100" height="72" src="~/assets/loose_setting/bandwidth.svg" alt="band width" />
					</div>
					<div class="top-icon">
						<SvgHeaderSvg :type="'ask'" />
					</div>
				</div>
				

				<div class="ring_box" v-if="settingComponent.diamond_spread !== ''" @click="openModal(ringParams.newDiamondSpread)">
					<div class="ring_box_left" >
						<!-- <h5 class="title_h5" v-if="settingComponent.diamond_spread === ''"> N/A</h5> -->
						<h5 class="title_h5" >{{ settingComponent.diamond_spread }}%</h5>
						<p class="mb-0">Diamond Spread</p>
					</div>
					<div class="ring_box_right" v-if="settingComponent.diamond_spread === '50'">
						<img width="100" height="72" src="~/assets/presetdetails/fifty.svg" alt="diamond spread" />
					</div>
					<div class="ring_box_right" v-if="settingComponent.diamond_spread === '75'">
						<img width="100" height="72" src="~/assets/presetdetails/seventyfive.svg" alt="diamond spread" />
					</div>
					<div class="ring_box_right" v-if="settingComponent.diamond_spread === '100'">
						<img width="100" height="72" src="~/assets/presetdetails/hundred.svg" alt="diamond spread" />
					</div>
					<div class="top-icon">
						<SvgHeaderSvg :type="'ask'" />
					</div>
				</div>
				
			</div>
			
			<div class="ring_data_flex" :class="dropring ? 'show' : 'hide'" v-if="settingComponent.num_side_lots">

				<div class="ring_box" @click="openModal(ringParams.newSideColour)">
					<div class="ring_box_left">
						<h5 class="title_h5">{{ settingComponent.side_stone.color }}</h5>
						<p class="mb-0">Side Stone <br>Color</p>
					</div>
					<div class="ring_box_right">
						<img width="100" height="72" src="~/assets/presetdetails/fg.svg" alt="side color" />
					</div>
					<div class="top-icon">
						<SvgHeaderSvg :type="'ask'" />
					</div>
				</div>
				

				<div class="ring_box" @click="openModal(ringParams.newSideClarity)">
					<div class="ring_box_left">
						<!-- <h5 class="title_h5">{{ settingComponent.side_stone.clarity }}</h5> -->
						<h5 class="title_h5"> {{ settingComponent.side_stone.clarity }}</h5>
						<p class="mb-0">Side Stone <br> Clarity</p>
					</div>
					<div class="ring_box_right">
						<img width="100" height="72" src="~/assets/presetdetails/vs.svg" alt="side stone" />
					</div>
					<div class="top-icon">
						<SvgHeaderSvg :type="'ask'" />
					</div>
				</div>
				

				<div class="ring_box" @click="openModal(ringParams.newShape)">
					<div class="ring_box_left">
						<h5 class="title_h5">{{ settingComponent.side_stone.diamonds }}</h5>
						<p class="mb-0">Side Stone <br>Quantity</p>
					</div>
					
					<div class="ring_box_right" v-if="settingComponent.side_stone_shape">
						<img width="56" height="56" src="~/assets/loose_setting/marquise.svg" alt="marquise"  v-if="settingComponent.side_stone_shape === 'Marquise'"/>
						<img width="56" height="56" src="~/assets/loose_setting/asscher.svg" alt="asscher" v-else-if="settingComponent.side_stone_shape === 'Asscher'"/>
						<img width="56" height="56" src="~/assets/loose_setting/cushion.svg" alt="cushion" v-else-if="settingComponent.side_stone_shape === 'Cushion'"/>
						<img width="56" height="56" src="~/assets/loose_setting/emerald.svg" alt="emerald" v-else-if="settingComponent.side_stone_shape === 'Emerald'"/>
						<img width="56" height="56" src="~/assets/loose_setting/heart.svg" alt="heart" v-else-if="settingComponent.side_stone_shape === 'Heart'"/>
						<img width="56" height="56" src="~/assets/loose_setting/oval.svg" alt="oval" v-else-if="settingComponent.side_stone_shape === 'Oval'"/>
						<img width="56" height="56" src="~/assets/loose_setting/pear.svg" alt="pear" v-else-if="settingComponent.side_stone_shape === 'Pear'"/>
						<img width="56" height="56" src="~/assets/loose_setting/princess.svg" alt="princess" v-else-if="settingComponent.side_stone_shape === 'Princess'"/>
						<img width="56" height="56" src="~/assets/loose_setting/radiant.svg" alt="radiant" v-else-if="settingComponent.side_stone_shape === 'Radiant'"/>
						<img width="56" height="56" src="~/assets/loose_setting/round.svg" alt="round" v-else-if="settingComponent.side_stone_shape === 'Round'"/>
						<img width="56" height="56" src="/loose_setting/trillion.svg" alt="round" v-else-if="settingComponent.side_stone_shape === 'Trillion'"/>
						<img width="56" height="56" src="/loose_setting/trapezium.svg" alt="round" v-else-if="settingComponent.side_stone_shape === 'trapezium'"/>
						<img width="100" height="72" src="~/assets/loose_setting/diamond.svg" alt="Diamond" v-else/>
					</div>
					
					<div class="top-icon">
						<SvgHeaderSvg :type="'ask'" />
					</div>
				</div>
				

				<div class="ring_box" @click="openModal(ringParams.newWeight)">
					<div class="ring_box_left">
						<h5 class="title_h5 capss">{{ settingComponent.side_stone.carat }}</h5>	
						<p class="mb-0">Total Carat <br> Weight</p>
					</div>
					<div class="ring_box_right">
						<!-- <div class="text-center ">
							<SvgShapeSvg :type="'princess'" /> <br>
							<SvgShapeSvg :type="'round'" />
							<SvgShapeSvg :type="'cushion'" />
						</div> -->
						<img width="90" height="72" src="~/assets/presetdetails/total_ct_w.svg" alt="quantity" />
					</div>
					<div class="top-icon">
						<SvgHeaderSvg :type="'ask'" />
					</div>
				</div>
				

			</div>

		</div>
		<!-- Ring setting end -->

		<!-- Diamond Detail Single -->
		<div class="diam_one mt-4 mt-md-5" v-if=" settingComponent && activeDiamondVariation">
			<div class="mb-3 title_flex" @click="toggleSingle()">
				<div class="font-active">
					<span>Diamond Details </span>
				</div>
				<SvgHeaderSvg class="for_mobile" :type="drowdown ? 'up' : 'down'" />
			</div>

			<div class="ring_data_flex" :class="drowdown ? 'show' : 'hide'">
				<div class="ring_box" @click="showModal(diamondParameters.carat)">
					<div class="ring_box_left">
						<h5 class="mb-1">{{ activeDiamondVariation.weight }} ct.</h5>
						<p>Carat</p>
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'marquise'">
						<img width="56" height="56" src="~/assets/loose_setting/marquise.svg" alt="marquise" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'asscher'">
						<img width="56" height="56" src="~/assets/loose_setting/asscher.svg" alt="asscher" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'cushion'">
						<img width="56" height="56" src="~/assets/loose_setting/cushion.svg" alt="cushion" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'emerald'">
						<img width="56" height="56" src="~/assets/loose_setting/emerald.svg" alt="emerald" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'heart'">
						<img width="56" height="56" src="~/assets/loose_setting/heart.svg" alt="heart" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'oval'">
						<img width="56" height="56" src="~/assets/loose_setting/oval.svg" alt="oval" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'pear'">
						<img width="56" height="56" src="~/assets/loose_setting/pear.svg" alt="pear" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'princess'">
						<img width="56" height="56" src="~/assets/loose_setting/princess.svg" alt="princess" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'radiant'">
						<img width="56" height="56" src="~/assets/loose_setting/radiant.svg" alt="radiant" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.shape === 'round'">
						<img width="56" height="56" src="~/assets/loose_setting/round.svg" alt="round" />
					</div>

					<div class="top-icon" >
						<span class="svgask">
							<SvgHeaderSvg :type="'ask'" />
						</span>
					</div>
				</div>				
				<div class="ring_box" @click="showModal(diamondParameters.color)">
					<div class="ring_box_left">
						<h5 class="mb-1 caps">{{ activeDiamondVariation.color.includes('-') ? activeDiamondVariation.color : activeDiamondVariation.color.split('').join('-') }}</h5>
						<p>Color</p>
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.color === 'fg'">
						<img width="90" height="72" src="~/assets/presetdetails/fg.svg" alt="side color" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.color === 'de'">
						<img width="90" height="72" src="~/assets/presetdetails/de.svg" alt="side color" />
					</div>
					<div class="top-icon" >
						<span class="svgask">
							<SvgHeaderSvg :type="'ask'" />
						</span>
					</div>
				</div>
				<div class="ring_box" @click="showModal(diamondParameters.clarity)">
					<div class="ring_box_left">
						<h5 class="mb-1 caps">{{ activeDiamondVariation.clarity  }}</h5>
						<p>Clarity</p>
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.clarity === 'vs'">
						<img width="90" height="72" src="~/assets/presetdetails/vs.svg" alt="side stone" />
					</div>
					<div class="ring_box_right" v-if="activeDiamondVariation.clarity === 'vvs'">
						<img width="90" height="72" src="~/assets/presetdetails/vvs.svg" alt="side stone" />
					</div>
					<div class="top-icon" >
						<span class="svgask">
							<SvgHeaderSvg :type="'ask'" />
						</span>
					</div>
				</div>
				<!-- <div class="ring_box">
					<div class="ring_box_left">
						<h5 class="mb-1">{{ activeDiamondVariation.cut_grade }}</h5>
						<p>Cut</p>
					</div>
					<div class="ring_box_right">
						<img width="100" height="100" :src="'/loose_graphics/newcut/' + lowercase(diamond.cut_grade) + '.svg'" alt="cut" />
					</div>
					<div class="top-icon" @click="showModal(diamondParameters.cut)">
						<span class="svgask">
							<SvgHeaderSvg :type="'ask'" />
						</span>
					</div>
				</div> -->
			</div>
		</div>

		<div class="mt-3 mt-md-4 ">
			<div class="ring_title mb-2 ms-md-2">
				<span class="prod_title">{{metal.values.product_name}}</span>    
				<span class="for_desktop"> | </span>
				<span class="prod_sku">SKU : {{ settingComponent.main_sku }}</span>
			</div>
			<div class="ring_desc ms-md-2">
				<span>{{description}}</span>
			</div>
        </div>
		<ModalLooseDetailModal 
			ref="modalRef"
			v-if="flagShowModal" :activeIndex="activeIndex" :diamondParameters="diamondParameters" :id="`modal-${activeIndex}`" :key="`${activeIndex}_diamond_detail_attr_modal`"
				@close="hideModal" :dData="activeDiamondVariation" type="preset"/>

		<ModalSettingStyle :item="settingComponent" type="preset" title="Style"
			:id="`modal-${ringParams.newstyle}`"
			@close="notOpenModal"
			v-if="flagShowModalReturn && ringBox === ringParams.newstyle"
			:ringBox="ringBox"/>

		<ModalSettingProfile :item="settingComponent" title="Profile"
			:id="`modal-${ringParams.newProfile}`"
			@close="notOpenModal"
			v-if="flagShowModalReturn && ringBox === ringParams.newProfile"
			:ringBox="ringBox"/>

		<ModalSettingBandwidth :item="settingComponent.width" title="Band Width" type="preset"
			:id="`modal-${ringParams.newBandwith}`"
			@close="notOpenModal"
			v-if="flagShowModalReturn && ringBox === ringParams.newBandwith"
			:ringBox="ringBox"/>

		<ModalSettingSideColour
			ref="newModalColor"
			:item="settingComponent.side_stone.color" title="Side Stone Color" type="preset"
			:id="`modal-${ringParams.newSideColour}`"
			@close="notOpenModal"
			v-if="flagShowModalReturn && ringBox === ringParams.newSideColour"
			:ringBox="ringBox"/>

		<ModalSettingDiamondSpread :item="settingComponent" title="Diamond Spread"
			:id="`modal-${ringParams.newDiamondSpread}`"
			@close="notOpenModal"
			v-if="flagShowModalReturn && ringBox === ringParams.newDiamondSpread"
			:ringBox="ringBox"/>

		<ModalSettingSideClarity :item="settingComponent.side_stone.clarity" title="Side Stone Clarity" type="preset"
			:id="`modal-${ringParams.newSideClarity}`"
			@close="notOpenModal"
			v-if="flagShowModalReturn && ringBox === ringParams.newSideClarity"
			:ringBox="ringBox"/>
		
		<ModalSettingShape :settingComponent="settingComponent" type="preset"
			:id="`modal-${ringParams.newShape}`"
			@close="notOpenModal"
			v-if="flagShowModalReturn && ringBox === ringParams.newShape"
			:ringBox="ringBox"/>

		<ModalSettingTotalWeight :item="settingComponent.side_stone.carat" title="Total Carat Weight"
			:id="`modal-${ringParams.newWeight}`"
			@close="notOpenModal"
			v-if="flagShowModalReturn && ringBox === ringParams.newWeight"
			:ringBox="ringBox"/>
	</div>
</template>

<script setup>

const route = useRoute();
const modalRef = ref(null)
const newModalColor = ref(null)

const flagShowModal = ref(false)
const show = ref(false);
const activeIndex = ref('');
const drowdown = ref(true);

const moduleSubType = route.meta.moduleSubType
const dropring = ref(true);

const ringBox = ref('');

const flagShowModalReturn = ref(false);

const ringParams = {
	newstyle : 'newstyle',
	newProfile : 'newProfile',
	newBandwith : 'newBandwith',
	newDiamondSpread : 'newDiamondSpread',
	newSideColour : 'newSideColour',
	newSideClarity : 'newSideClarity',
	newShape : 'newShape',
	newWeight : 'newWeight'
}

const openModal = (newbox) => {
	ringBox.value = newbox;
	flagShowModalReturn.value = true;
	console.log(ringBox.value,'abc',newbox);
	nextTick(() => {
		const modalElement = document.getElementById(`modal-${ringBox.value}`);
		console.log(modalElement,'asd',ringBox.value);
		if (modalElement) {
			const modalInstance = new bootstrap.Modal(modalElement);
			modalInstance.show();
		}
		modalElement.addEventListener('shown.bs.modal', () => {
                if (newModalColor.value) {
                    newModalColor.value.scrollToHighlightedImage();
                }
            });
	});
}
const notOpenModal = () => {
	const modalElement = document.getElementById(`modal-${ringBox.value}`);
	if (modalElement) {
		const modalInstance = bootstrap.Modal.getInstance(modalElement);
		if (modalInstance) {
			modalInstance.hide();
		}
	}
		flagShowModalReturn.value = false;
		ringBox.value = '';
};


const diamondParameters = {
	color: 'color',
	cut: 'cut',
	carat: 'carat',
	clarity: 'clarity'
}

const props = defineProps ({
    description: String,
    settingComponent : Object,
    activeDiamondVariation : Object,
    metal : Object
})


const toggleSingle = () => {
	drowdown.value = !drowdown.value;
};

const toggleRing = () => {
	dropring.value = !dropring.value;
};

const showModal = (boxNumber) => {
	flagShowModal.value = true;
	activeIndex.value = boxNumber;
	nextTick(() => {
		const modalElement = document.getElementById(`modal-${activeIndex.value}`);
		if (modalElement) {
			const modalInstance = new bootstrap.Modal(modalElement);
			modalInstance.show();
		}
		modalElement.addEventListener('shown.bs.modal', () => {
		if (modalRef.value) {
			modalRef.value.scrollToHighlightedImage();
			modalRef.value.scrollToclairtyImage();
			modalRef.value.handleScrollToHighlightedImage();
		}
		});
	});
};

const hideModal = () => {
	const modalElement = document.getElementById(`modal-${activeIndex.value}`);
	if (modalElement) {
		const modalInstance = bootstrap.Modal.getInstance(modalElement);
		if (modalInstance) {
			modalInstance.hide();
		}
	}
	flagShowModal.value = false;
};

</script>


<style scoped>


h5,
p {
	margin: 0;
}

h5 {
	color: #212529;
	font-size: 20px;
	font-weight: 600;
	margin-bottom: 5px;
}

p {
	font-size: 14px;
	line-height: 20px;
	text-transform: uppercase;
	color: #606060;
	letter-spacing: 1.5px;
}

.ring_data_flex {
	display: flex;
	align-items: flex-start;
	justify-content: center;
}

.ring_box {
	width: 24%;
	border: 1px solid #eaeaea;
	border-radius: 8px;
	margin: 10px;
	padding: 13px;
	position: relative;
	display: flex;
	align-items: center;
	min-height: 100px;
	cursor: pointer;
}

.ear_diam_block {
	display: flex;
}

.ear_diam_block .ring_data_flex {
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-wrap: wrap;
}

.ring_border{
	border-right: 2px dashed #c4c4c4;
}


.title_flex {
	font-size: 28px;
	text-align: center;
	color: #242529;
	text-transform: capitalize;
}

.ring_box_mod {
	width: 44%
}

.ring_box_left {
	width: 60%;
}

.ring_box_left .caps {
	text-transform: uppercase;
}


.ring_box_right {
	width: 40%;
	text-align: center;
}

.ring_box_left p {
	font-size: 14px;
	color: #606060;
	text-transform: uppercase;
}

.diamond_box {
	border: 1px solid #eaeaea;
	border-radius: 8px;
	margin: 10px;
	padding: 13px;
	position: relative;
	display: flex;
	align-items: flex-start;
	min-height: 100px;
}

.diamond_box_left,
.box2 {
	width: 50%;
}

.diamond_box_left {
	margin: 4px 6px;
}

.diamond_box_right {
	text-align: right;
}


.top-icon {
	top: 4px;
	right: 2px;
	position: absolute;
	cursor: pointer;
}

.capss {
	text-transform: capitalize;
}

.svgask {
	cursor: pointer;
}

.carat_icons {
	display: flex;
	justify-content: center;
}

.prod_title{
	font-size: 16px;
	color: #353535;
	font-weight: 600;
}
.prod_sku{
	font-size: 16px;
	color: #606060;
}

.ring_desc{
	font-size: 16px;
	color : #606060;
}
/* Responsive Design */
@media(max-width: 1150px) {
	.ring_box {
		margin: 5px;
	}

	h5 {
		font-size: 18px;
	}

	.ring_box_mod {
		width: 46%;
	}

	.ear_diam_block {
		display: flex;
		flex-direction: column;
	}
	.ring_border{
		border-right: none;
	}
	.ear_diam_block .ring_data_flex {
		width: 100%;
		justify-content: space-around;
	}

}

/* @media (max-width: 1200px) {

	h5 {
		font-size: 14px;
	}

	p {
		font-size: 11px;
	}

} */


@media(max-width: 992px) {
	.ring_data_flex {
		flex-wrap: wrap;
		/* justify-content: space-between; */
	}

	.ring_box .ring_box_mod {
		width: 100%;
	}

	.ring_box {
		width: 31%;
		margin: 7px;
	}

}

@media (max-width: 767px) {

	.title_flex {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 18px;
		margin: 5px 0;
	}

	h5 {
		font-size: 18px;
	}

	.ring_data_flex.hide {
		display: none;
	}

	.ring_data_flex {
		justify-content: space-between;
	}

	.ring_box {
		width: 48%;
		flex-wrap: wrap;
		flex-direction: column-reverse;
		padding: 13px 5px;
		margin: 6px 0;
	}

	.ring_box_left,
	.ring_box_right {
		width: 100%;
		text-align: center;
	}

	.ring_box_left {
		margin-top: 10px;
	}

	.diamond_box_left,
	.diamond_box_right {
		width: 100%;
		text-align: center;
	}

	.flip .diamond_box_left {
		text-align: left;
	}


	.diamond_box_left,
	.diamond_box_right {
		margin: 0px;
	}

	.flip {
		min-height: 90px;
		text-align: left;
	}
	.prod_title , .prod_sku ,  .ring_desc {
		font-size: 14px;
		display: block;
    }

	.ring_box_left p {
		font-size: 12px;
	}
	
	/* .ring_box_left p br{
        display: none;
    } */
}
</style>

